import CryptoJS from 'crypto-js';

export const encryptData = (data, SECRET_KEY) => {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  return ciphertext;
};

export const decryptData = (encryptedText, SECRET_KEY) => {
  const bytes = CryptoJS.AES.decrypt(encryptedText, SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};
